import { render, staticRenderFns } from "./Barriers.vue?vue&type=template&id=010cc8de&scoped=true"
import script from "./Barriers.vue?vue&type=script&lang=js"
export * from "./Barriers.vue?vue&type=script&lang=js"
import style0 from "./Barriers.vue?vue&type=style&index=0&id=010cc8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cc8de",
  null
  
)

export default component.exports